import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Button from 'components/button';

import { ErrorWrapper, ErrorTitle, ErrorText } from './elements';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
    this.handleBackToHome = this.handleBackToHome.bind(this);
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  handleBackToHome() {
    const { history } = this.props;
    history.push('/');
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorWrapper>
          <div style={{ width: '80%' }}>
            <ErrorTitle>Something went wrong!</ErrorTitle>
            <ErrorText>
              Please refresh to try again or click below to go to home page.{' '}
            </ErrorText>
            <Button
              width="200px"
              color="yellow"
              onClick={() => window.location.reload()}
            >
              Refresh
            </Button>
            <Button
              width="200px"
              color="yellow"
              onClick={this.handleBackToHome}
            >
              Back to home
            </Button>
          </div>
        </ErrorWrapper>
      );
    }
    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
